import React from 'react'
import injectSheet from 'react-jss'
import {
  Tile,
  Image,
} from '../../'

const IconTile = (props) => {
  const {
    classes,
    conflicts,
    disabled,
    handleClick,
    index,
    isSelected,
    node,
    requires,
    wide,
  } = props

  return (
    <div className={`${classes.tileContainer} ${isSelected && classes.selected} ${wide && 'wide'}`}>
      <Tile
        conflicts={conflicts}
        disabled={disabled}
        index={index}
        isSelected={isSelected}
        onClick={() => handleClick()}
        requires={requires}
      >
        <div className={`${classes.contentWrapper}`}>
          <div className={`${classes.contentContainer}`}>
            {(node.images && Array.isArray(node.images)) && (
              <div className={`${classes.imageContainer}`}>
                <Image
                  src={node.images[0]}
                  alt={node.title}
                />
              </div>
            )}
            <h3 className={`${classes.tileName}`}>
              {node.title}
            </h3>
          </div>
        </div>
      </Tile>
    </div>
  )
}

const styles = theme => ({
  tileContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    backgroundColor: `${theme.colors.main_2}`,
  },
  contentWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  contentContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  imageContainer: {
    width: `${100 * theme.ratio.icon * theme.ratio.tile}vw`,
    height: `${(100 * theme.ratio.icon) / theme.ratio.tile}vw`,
    [theme.media.medium]: {
      height: `${((100 * theme.ratio.icon) / 3) / theme.ratio.tile}vw`,
      maxHeight: `${((theme.sizes.container * theme.ratio.icon) / 3) / theme.ratio.tile}px`,
      width: `${((100 * theme.ratio.icon) / 3) * theme.ratio.tile}vw`,
    },
  },
  tileName: {
    width: '100%',
    textAlign: 'center',
  },
})

export default injectSheet(styles)(IconTile)



// WEBPACK FOOTER //
// ./src/modules/core/components/iconTile.jsx